<template>
  <ChecklistContainer />
</template>

<script lang="ts">
import Vue from "vue";
import ChecklistContainer from "@/components/checklists/checklist/container/ChecklistContainer.vue";

export default Vue.extend({
  components: {
    ChecklistContainer,
  },
});
</script>
